import { Injectable } from '@angular/core';
import { ListFilters, UrlCodecs } from 'src/app/shared/ExtendedListService';
import type { DocumentStatus } from '@proxy/documents';

/**
 * DocumentsService's DTO (GetDocumentListDto) has no availableUntil/documentStatus,
 * TenantDocumentService's (GetTenantDocumentListDto) has no creatorId - same asymmetry as
 * courses. This declares the full set the component already sends to either service.
 */
export interface DocumentListFilterFields {
  categoryId?: string;
  testId?: string;
  availableUntil?: string;
  creationDateFrom?: string;
  creationDateTo?: string;
  documentStatus?: DocumentStatus;
  creatorId?: string;
}

@Injectable()
export class DocumentFilters extends ListFilters<DocumentListFilterFields> {
  readonly schema = {
    categoryId: UrlCodecs.string,
    testId: UrlCodecs.string,
    availableUntil: UrlCodecs.isoDateString,
    creationDateFrom: UrlCodecs.isoDateString,
    creationDateTo: UrlCodecs.isoDateString,
    documentStatus: UrlCodecs.int,
    creatorId: UrlCodecs.string,
  };
}
